import { useState } from 'react';

const useModal = (openCallback = () => {}) => {
	const [show, setShow] = useState(false);

	const handleOpen = (e) => {
		setShow(true);
		openCallback(e);
	};
	const handleClose = () => {
		setShow(false);
	};

	return {
		show,
		handleOpen,
		handleClose
	};
};

export default useModal;
